(() => {
  'use strict';
  document.addEventListener('change', event => {
    const select=event.target.closest('[data-variant-select]');
    if(!select) return;
    const option=select.selectedOptions[0], form=select.closest('form');
    if(!option || !form) return;
    const button=form.querySelector('[data-add-button]');
    const available=option.dataset.available==='true';
    button.disabled=!available;
    button.replaceChildren(document.createTextNode(available?button.dataset.label+' · '+option.dataset.price:button.dataset.soldOut));
    const hero=form.closest('.product-hero-copy');
    const price=hero?.querySelector('[data-product-price]');
    if(price)price.textContent=option.dataset.price;
    const media=form.closest('.product-hero')?.querySelector('[data-variant-media]');
    if(media && option.dataset.image)media.src=option.dataset.image;
    if(hero){
      const url=new URL(window.location.href);url.searchParams.set('variant',option.value);
      window.history.replaceState({},'',url);
    }
  });
  // Native Shopify forms handle add-to-cart, quantity updates and checkout,
  // including when JavaScript is unavailable.
})();
